
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/developers/become-a-developer",
      function () {
        return require("private-next-pages/developers/become-a-developer.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/developers/become-a-developer"])
      });
    }
  